// removed by extract-text-webpack-plugin
module.exports = {"imageWrapper":"_35xisHQKIM8xxSwbbh1gdn"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RichEditor/components/ImageComponent.scss
// module id = 375
// module chunks = 0